import React from 'react';
import {View} from 'react-native';

import Screen from '../../shared/components/screen';

import {Props} from './model';
import {images} from '../../assets/icons';

import {useStyles} from '../../shared/hooks/styles';
import {DeviceSize, useDeviceSize} from '../../shared/theme/helpers';
import {Routes, Screens} from '../../shared/routing';
import {SocialSupportMeasuresLink} from './link';
import {ResponsiveView} from '../../shared/components/responsiveView';
import {Text} from '../../shared/components/text';
import {CustomScrollView} from '../../shared/components/scrollView';
import {ContentWithRightImage} from '../../shared/components/contentWithRightImage';

export default ({}: Props) => {
  const deviceSize = useDeviceSize();
  const styles = useStyles(({theme, mediaOnly}) => ({
    sectionContainer: {
      paddingBottom: theme.screen.bottomOffset,
      ...mediaOnly(
        DeviceSize.desktop,
        {marginTop: 32, paddingHorizontal: 24},
        {
          marginTop: 28,
          paddingHorizontal: 35,
        },
      ),
    },
    sectionTitle: {
      ...theme.fonts.h2,
      marginBottom: 40,
    },
    contentText: {
      ...mediaOnly(
        DeviceSize.desktop,
        {
          ...theme.fonts.h6Light,
          marginBottom: 30,
        },
        {
          ...theme.fonts.additionalText,
          marginBottom: 35,
        },
      ),
    },
    links: {
      ...mediaOnly(DeviceSize.desktop, {width: 636}, {width: '100%'}),
    },
    linkItem: {
      ...mediaOnly(
        DeviceSize.desktop,
        {
          marginTop: 36,
        },
        {marginTop: 20},
      ),
    },
    linkItemFirst: {
      marginTop: 0,
    },
    contentWithRightImageBackgroundStyle: {right: 5},
    contentWithRightImageIconStyle: {paddingRight: 44, color: theme.supportService.iconsColor.socialSupport},
    content: {
      minHeight: 520,
    },
  }));

  return (
    <Screen>
      <CustomScrollView contentInsetAdjustmentBehavior='automatic'>
        <View style={styles.sectionContainer}>
          <ResponsiveView only={[DeviceSize.desktop]}>
            <Text style={styles.sectionTitle}>Меры социальной поддержки</Text>
          </ResponsiveView>
          <ContentWithRightImage
            icon={<images.SocialSupport width={441} height={403} hideForVisuallyImpaired />}
            backgroundStyle={styles.contentWithRightImageBackgroundStyle}
            iconStyle={styles.contentWithRightImageIconStyle}
            contentStyle={styles.content}
            hideImage={deviceSize !== DeviceSize.desktop}>
            {/* <Text style={styles.contentText}>{content.socialSupportMeasuresText}</Text> */}
            <View style={styles.links}>
              <View style={[styles.linkItem, styles.linkItemFirst]}>
                <SocialSupportMeasuresLink
                  href={Routes.statePrograms}
                  screen={Screens.StatePrograms}
                  title='Государственные программы'
                />
              </View>
              <View style={[styles.linkItem]}>
                <SocialSupportMeasuresLink
                  href={Routes.stateAssignments}
                  screen={Screens.StateAssignments}
                  title='Государственные задания'
                />
              </View>
              <View style={[styles.linkItem]}>
                <SocialSupportMeasuresLink
                  href={Routes.expenseLiabilities}
                  screen={Screens.ExpenseLiabilities}
                  title='Реестр расходных обязательств'
                />
              </View>
            </View>
          </ContentWithRightImage>
        </View>
      </CustomScrollView>
    </Screen>
  );
};
